import axios from 'axios'

export default {
    getClaims(filter, isFirst50Items) {
        filter.isFirst50Items = isFirst50Items;
        return axios.get('/api/costcoreports',
            {
                params: filter
            });
    },
    getParts(page, filter) {
        return axios.get('/api/parts/report',
            {
                params: {
                    page: page,
                    ...filter
                }
            });
    },
    getUsedParts(page, filter) {
        return axios.get('/api/parts/usedpartsreport',
            {
                params: {
                    page: page,
                    ...filter
                }
            });
    },
    getCodes(page, filter) {
        return axios.get('/api/resolutioncodes/report',
            {
                params: {
                    page: page,
                    ...filter
                }
            });
    },
    downloadReport(filter) {
        return axios.get('/api/costcoreports/excel',
            {
                params: filter,
                responseType: 'blob'
            });
    },
    downloadClaimReport(filter) {
        return axios.post('/api/claimreport/excel', filter,
            {
                responseType: 'blob'
            });
    },
    downloadServiceTicketsReport(filter) {
        return axios.post('/api/serviceticketsreport/excel', filter,
            {
                responseType: 'blob'
            });
    },
    download(filter) {
        return axios.download('/api/resolutioncodes/export',
            {
                productId: filter.productId,
                categoryId: filter.categoryId,
                description: filter.description,
                code: filter.description
            });
    },
    getDataForGraph(filter) {
        return axios.get(`/api/graphs/${filter.periodType}/${filter.productId}`);
    },
    getFilterForGraph() {
        return axios.get('/api/graphs/filters');
    },
    downloadPriceList(filter) {
        return axios.download('/api/parts/exportpricelist', {
            part: filter.part,
            serviceCompany: filter.serviceCompany
        });
    },
    downloadUsedParts(filter) {
        return axios.download('/api/parts/exportusedparts',
            {
                part: filter.part,
                claimNumber: filter.claimNumber,
                dateFrom: filter.dateFrom,
                dateTo: filter.dateTo,
                serviceCompany: filter.serviceCompany
            });
    },
    downloadRmaReport(filter) {
        return axios.post('/api/rmareport/excel', filter,
            {
                responseType: 'blob'
            });
    },
    downloadSimsApReport(filter) {
        return axios.post('/api/simsapreport/excel', filter,
            {
                responseType: 'blob'
            });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/reports/api.js